export default __webpack_public_path__ + "static/media/sort-white.93c3c357.svg";